/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */

var Model = require("../types/Model.js");
var xtend = require("xtend");

module.exports = Model({
	name: "activity",
	init: init,
	uninit: uninit,
	triggers: triggers,
	listeners: listeners,

	_history: null,
	_cumulative: null,
	_page: null,
	_who: null,

	refresh: refresh,
	reset: reset,
	sayViewing: sayViewing,
	tracker: tracker,
	setCumulative: setCumulative,
	setShortTerm: setShortTerm
});

function init() {
	this._who_tracker = this.dispatcher.createTracker();
	this.reset();
	this.refresh();
}

function uninit() {
	this._who = null;
	this._who_tracker.off();
	this._who_tracker = null;
}

function triggers() {
	return {
		"view": view,
		"reset": reset,
		"record": recordActivity,
		"recordtodevicereading": recordActivityToDeviceReading,
		"savebeforeconfirm": save_and_prompt_confirm,
		"load": refresh
	};
}

function listeners() {
	return {
		"connectivity:online": refresh,
		"mqtt:$/observations/steps": refresh,
		"atouchawaysettings:updated": handle_update,
		"atouchawaymobile:page": update_page
	};
}

function view() {
	this.refresh()
		.then(sayViewing.bind(this));
	this.emit("usermetrics:trigger:track", "view own activity");
}

function sayViewing() {
	this.dispatch("viewing");
}


function reset() {
	this.extend({
		cumulative: [],
		short: [],
		reverse: []
	});
	this.emit("usermetrics:trigger:track", "close own activity");
}


function refresh() {
	this.emit("save:trigger:start");
	return this.api.device.activity.steps
		.history()
		.then(setCumulative.bind(this))
		.then(setShortTerm.bind(this))
		.then(setReverse.bind(this))
		.catch((e) => {
			!e?.status === 500 && console.error(e);
		})
		.then(finish_load.bind(this))
		.then(tracker.bind(this));
}

function save_and_prompt_confirm(data) {
	var activity = data.value;

	this._latestActivity = data;
	this.extend({
		latestreading: activity,
	});
	this.emit("usermetrics:trigger:track", "open confirm submit activity popup");
	return this.emit("newreading:trigger:confirm");
}

function recordActivity() {
	var value = this._latestActivity;
	value.manual = true;
	value.timestamp = new Date();
	this.emit("usermetrics:trigger:track", "record own activity", {
		value: value
	});
	return this.api.device.activity.steps.add(value)
		.catch(console.log.bind(console))
		.then(jumpToEdited.bind(this));
}

function recordActivityToDeviceReading() {
	var value = this._latestActivity;

	const resolve = Promise.resolve(value);
	this.emit("usermetrics:trigger:track", "record own activity to device reading");
	return resolve.catch(console.log.bind(console))
		.then(res => {
			this.emit("myhealthdevice:activity:reading", {value: res});
			this.emit("myhealthdevice:trigger:clean");
			jumpToEdited.bind(this)();
		});
}

function jumpToEdited() {
	this._latestActivity = null;
	return this.emit("newreading:trigger:hide");
}

function setCumulative(data) {
	var who = data[0].who;
	this._who = who;
	var dateformatted = data.map(function (item) {
		var date = item.created_at;
		var formatted_date = timestamp(date);
		return xtend(item, {
			latest_time: item.updated_at,
			updated_at: formatted_date
		});
	});

	this.extend({
		cumulative: dateformatted,
		latest: dateformatted[0]
	});

	return dateformatted;
}

function tracker() {
	var who = this._who;
	var whoTracker = this._who_tracker;
	whoTracker.off();
	whoTracker.on("mqtt:u/" + who + "/settings", reloadIfTestModeOff.bind(this));
}

function reloadIfTestModeOff(data) {
	if(data.testModeEnabled === null) {
		this.refresh();
	}
}


function setShortTerm(data) {
	var short_term = data.slice(1, 6); //subset for preceding days
	this.extend({
		short: short_term
	});
	return data;
}

function setReverse(data) {
	var reverse =  data.reverse();

	this.extend({
		reverse: reverse
	});
}

function finish_load() {
	this.emit("save:trigger:finish");
}

function handle_update(data){
	var myhealth = data.myhealth;

	if(!myhealth && this._page === "activity"){
		this.emit("atouchawaymobile:trigger:page", {
			page: "contacts"
		});
	}
}

function update_page(data){
	this._page = data.page;
}

function timestamp(date_string) {
	var date = new Date(date_string);
	var year = date.getFullYear();
	var month = date.getMonth() + 1;
	var day = date.getDate();

	// Check for NaN, if year or hours is NaN, so is everything else so just
	// return an empty string
	if (isNaN(year)) {
		return "";
	}

	// Numbers should be two digits, less than '10' are preceded by '0'
	function fill(number) {
		if (number.toString().length < 2) {
			return "0" + number;
		}
		return number;
	}

	var result = "";

	result += fill(month) + "-" + fill(day) + " ";

	return result;
}
